import 'katex/dist/katex.min.css'; // For react-latex-next
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./global.scss";
import { GlobalStateProvider } from "./global-state-context";
import LimiteDeErro from "./components/limite-de-erro";
import "./components/limite-de-erro.scss";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
// O limite de erro fica ACIMA do provedor de estado, e nao dentro dele, porque o provedor
// tambem pode falhar: ele fala com o Firebase na montagem. Um limite abaixo dele nao pegaria
// justamente a falha mais provavel.
root.render(
  <LimiteDeErro>
    <GlobalStateProvider>
      <App />
    </GlobalStateProvider>
  </LimiteDeErro>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
